"use strict"
import './components/config'
import './components/header'
import './components/slider'
import './components/animations'
import './components/fixed-buttons'
import './components/data-scr'
import './components/lazyframes'
